// image-processing-loader
var previousRequest = require("!!../../../../../../node_modules/fox-file-loader/index.js!../../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./promotion_bg.png");
var dir = previousRequest.replace("promotion_bg.png", "")
module.exports = require("!../../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "promotion_bg.png",
	name: "promotion_bg",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/join/promotion_bg.png
// module id = 1066
// module chunks = 4